var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#34D399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77844 13.3165C4.69019 13.2245 4.62016 13.1152 4.57238 12.9947C4.5246 12.8743 4.5 12.7452 4.5 12.6148C4.5 12.4844 4.5246 12.3553 4.57238 12.2348C4.62016 12.1144 4.77844 11.9131 4.77844 11.9131H4.79658C4.97457 11.727 5.21581 11.6225 5.46732 11.6225C5.71883 11.6225 5.96006 11.727 6.13806 11.9131L10.2207 16.0947L18.8844 7.29398C18.9727 7.20085 19.0777 7.12693 19.1933 7.07649C19.309 7.02605 19.433 7.00008 19.5583 7.00008C19.6836 7.00008 19.8077 7.02605 19.9233 7.07649C20.039 7.12693 20.144 7.20085 20.2322 7.29398L20.223 7.28389C20.4004 7.47046 20.5 7.72301 20.5 7.98628C20.5 8.24955 20.4004 8.50211 20.223 8.68867L10.2207 19L4.77844 13.3165Z",
    fill: "#18181B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCompleted);
export default ForwardRef;